/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { OpaqueToken  } from "@angular/core";

export interface IInaxConfig {
    Url: string;
    Username: string;
    Password: string;
    DefaultLanguage: string;
    UseSignalR: boolean;
    readonly SignalRHubs: string[];
    EnabledSignalRHubs: string[];
}

export interface IInaxConfigService {
    setConfiguration(configuration: IInaxConfig): void;
    getConfiguration(): BehaviorSubject<IInaxConfig>;
}

export const IINAXCONFIGSERVICE_TOKEN: OpaqueToken = new OpaqueToken('IInaxConfigService');